<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>预约管理</el-breadcrumb-item>
      <el-breadcrumb-item>个人预约</el-breadcrumb-item>
      <el-divider></el-divider>
    </el-breadcrumb>

    <div>
      <el-input placeholder="请输入预约号" prefix-icon="el-icon-search" @input="input" v-model="id"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="serachclick">搜索</el-button>
    </div>
    <!-- 个人预约 -->
    <el-table :data="userlist" border style="width: 100%">
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column class="text" prop="username" label="预约姓名" > </el-table-column>
      <el-table-column class="text" prop="number" label="预约ID" > </el-table-column>
      <el-table-column class="text" prop="mobile" label="预约手机" > </el-table-column>
      <el-table-column class="text" label="操作" width="300" >
      <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看" placement="top-end">
            <el-button type="primary" @click="modelClick(scope.row.number)" icon="el-icon-search" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top-end">
            <el-button type="danger" @click="removeUserById(scope.row.id)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="成绩统计" placement="top-end">
            <el-button type="Success" @click="Statistics(scope.row.number)" icon="el-icon-s-tools" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="开关" placement="top-end">
            <el-switch
              @change="wgswitch(scope.row)"
              v-model="scope.row.switchs"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格 -->
    <el-dialog class="tabClick" title="预约名单" :visible.sync="dialogTableVisible">
      <el-table :data="fraction">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column class="text" prop="times" label="考试时间"> </el-table-column>
        <el-table-column class="text" prop="examinationTime" label="考试用时"> </el-table-column>
        <el-table-column class="text" prop="fraction" label="实训考试成绩"> </el-table-column>
        <el-table-column class="text" prop="RQfraction" label="隐患考试成绩"> </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 分页 -->
    <div class="block">
      <el-pagination 
      @size-change="handleSizeChange" 
      :hide-on-single-page="value"
      @current-change="handleCurrentChange" 
      :page-sizes="[5, 10, 15, 20]" 
      :page-size="100" 
      layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- <div v-for="(it, idx) in SXexamArr" :key="idx">
      {{it.i}}
      {{it.fs}}
    </div>
    <div v-for="(it, idx) in YHexamArr" :key="idx">
      {{it.i}}
      {{it.fs}}
    </div> -->

    <el-dialog class="tabClick" title="预约名单" :visible.sync="dialogTableVisibles">
      <el-table :data="RQcless.SXexamArr">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column class="text" prop="i" label="实训考项"></el-table-column>
        <el-table-column class="text" prop="fs" label="实训考试成绩"></el-table-column>
        <!-- <el-table-column class="text" prop="text" label="隐患考试成绩"> </el-table-column> -->
      </el-table>
      <div>实训考试考题数:  {{RQcless.SXexamArr.length * 10}}</div>
      <el-table :data="RQcless.YHexamArr">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column class="text" prop="i" label="隐患考项"> </el-table-column>
        <el-table-column class="text" prop="fs" label="隐患考试成绩"> </el-table-column>
      </el-table>
      <div>隐患排查考题数:  {{RQlengths}}</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      RQcless: {
      SXexamArr: [],
      YHexamArr: []},
      dialogTableVisible: false,
      dialogTableVisibles: false,
      value: false,
      // 获取考题列表的参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少数据
        pagesize: 5
      },
      // 修改表单
      editForm: {
        username: '',
        number: '',
        mobile: '',
        id:''
      },
      userlist: [],
      total: 0,
      id: '',
      fraction: [],
      RQfraction: [],
      absss: 'aaaaaaaaa',
      RQlengths: 0
    }
  },
  created () {
    this.getUserList()
  },
  methods: {
    async getUserList () {
      const {data:res} = await this.$http.post('/pagingAppointment',{ params: this.queryInfo })
      console.log(res.users);
      this.userlist = res.users
      this.total = res.totalpage
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.queryInfo.pagesize = val
      this.getUserList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.queryInfo.pagenum = val
      this.getUserList()
    },

    //搜索
    async serachclick () {
      this.queryInfo.query = this.id
      console.log(this.queryInfo);
      this.getUserList()
      
      // const res = await this.$http.post('/pagingAppointment',{ params: this.queryInfo })
            // console.log(res);
      // this.userlist = res.data
      this.id = ''
    },
    input(val) {
      console.log(val);
      this.id = val
    },

    // 删除按钮
    async removeUserById (id) {
      const confirmResult = await this.$confirm('此操作将永久删除该用户，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除!')
      }
      console.log(111)
      const { data } = await this.$http.delete('/appointment/remove/' + id)
      this.$message.success('用户删除成功!')
      // // 刷新
      this.getUserList()
    },
    async modelClick(number) {
      console.log(number);
      const { data: res } = await this.$http.get(`/fractionFS/${number}`)
      console.log(res);
      this.fraction = res
      this.dialogTableVisible = true
    },
    async Statistics(number) {
      this.RQlengths = 0
      const { data: res } = await this.$http.get(`/fractionFS/${number}`)
      console.log(res);
      // 实训考试数组
      var hiddeDanger = []
      // 隐患排查数组
      var PracticalTraining = []
      // 实训考试数组
      var SXexamArr = []
      // 隐患考试数组
      var YHexamArr = []
      // 隐患排查考题数量
      var YHeaxmlength = 0
      for (const i in res) {
        // 处理实训考试数组
        if (res[i].fraction) {
          let arr1 = res[i].fraction.split('：')[0] //输出：分隔符测试前面
          let arr2 = res[i].fraction.split('：')[1] //输出：分隔符测试后面
          hiddeDanger.push({[arr1]: arr2})
          SXexamArr.push({i: arr1, fs: arr2})
          // 处理隐患排查数组
        } else if (res[i].RQfraction) {
          let arr1 = res[i].RQfraction.split('：')[0] //输出：分隔符测试前面
          let arr2 = res[i].RQfraction.split('：')[1] //输出：分隔符测试后面
          PracticalTraining.push({[arr1]: arr2})
          YHexamArr.push({i: arr1, fs: arr2})
          var strs = arr1
          strs = strs.slice(4, strs.length)
          this.optionText(strs)
          const { data: reess } = await this.$http.post('/pagingRQCODE', {"query": this.absss})
          this.RQlengths += reess.users.length
          console.log(this.RQlengths);
        }
      }
      console.log(hiddeDanger);
      console.log(PracticalTraining);
      console.log(SXexamArr);
      console.log(YHexamArr);
      this.RQcless.SXexamArr = SXexamArr
      this.RQcless.YHexamArr = YHexamArr
      this.dialogTableVisibles = true
    },

    // 计算隐患字符串
    optionText(options) {
      if (options == '便民超市') {
				this.absss = '3-4-'
			} else if (options == '餐饮店厨房') {
				this.absss = '3-3-'
			} else if (options == '居住出租屋') {
				this.absss = '3-6-'
      } // else if (options == '特种设备') {
			// } else if (options == '用电安全') {
			// } else if (options == '国家安全') {
			// } else if (options == '生态治理') {
			else if (options == '建筑工地安全') {
				this.absss = '4-3-'
			} else if (options == '客运车安全') {
				this.absss = '3-8-'
			} else if (options == '燃气安全') {
				this.absss = '4-1-'
			} else if (options == '生产车间') {
				this.absss = '4-2-'
			} else if (options == '食品加工小作坊') {
				this.absss = '3-1-'
			} else if (options == '书店') {
				this.absss = '2-5-'
			} else if (options == '童装厂') {
				this.absss = '3-5-'
			} else if (options == '网吧') {
				this.absss = '2-4-'
			} else if (options == '校车安全') {
				this.absss = '2-6-'
			} else if (options == '校园警务室') {
				this.absss = '2-2-'
			} else if (options == '学生宿舍') {
				this.absss = '2-1-'
			} else if (options == '寄递安全') {
				this.absss = '3-7-'
			}
    },
    async wgswitch (e) {
      const { data: res } = await this.$http.post(`/appointment/switchs/${e.number}`, {switchs: e.switchs})
      if (e.switchs === true) {
        this.$message.success('账号开启成功!')
      } else {
        this.$message.success('账号冻结成功!')
      }
    }
  }, 
}
</script>

<style lang="less" scoped>
/deep/.cell {
  text-align: center;
  font-size: 16px;
}
/deep/ .el-input--prefix {
  width: 300px;
}
/deep/ .el-breadcrumb {
  margin-bottom: -10px;
}
/deep/.el-switch {
  padding-left: 12px;
}
</style>
